import { assets } from "../../mock";

const FilmSection = () => {
  return (
    <section className="film" id="film">
      <div className="film-wrap">
        <video autoPlay muted loop playsInline preload="metadata" poster={assets.filmPoster}>
          <source src={assets.filmVideo} type="video/mp4" />
        </video>
        <div
          className="film-image film-image--fallback"
          style={{ backgroundImage: `url(${assets.filmPoster})` }}
        />
        <div className="film-overlay">
          <div className="wrap film-top reveal">
            <div className="film-title">
              <div className="kicker kicker--light">05 — In motion</div>
              <h2>
                Architecture
                <br />
                <span className="accent">is an experience.</span>
              </h2>
            </div>
          </div>
          <div className="wrap film-bottom reveal">
            <p>
              We create architecture that is not simply seen, but experienced — through atmosphere, materiality, proportion, light, and movement.
            </p>
            <div className="film-tag">ODDA / Film 01</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FilmSection;
